import { render, staticRenderFns } from "./ProductsDeleteDialog.vue?vue&type=template&id=972e9c34&scoped=true"
import script from "./ProductsDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ProductsDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductsDeleteDialog.vue?vue&type=style&index=0&id=972e9c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e9c34",
  null
  
)

export default component.exports